/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CollectionsViewModel {
  patientId?: string;
  accountNumber?: number;
  patientFirstName?: string | null;
  patientLastName?: string | null;
  visitId?: string;
  visitNumber?: number;
  financialClass?: string | null;
  balance?: number;
  assignDate?: string | null;
  followUpDate?: string | null;
  lastPaymentDate?: string | null;
  isScheduledWriteOff?: boolean;
  readonly queue?: string | null;
  readonly iconType?: string | null;
  readonly resultDescription?: string | null;
  readonly additionalDetails?: Array<string> | null;
}
